import { ENUM__image_orientation } from '../+image/_enums/ENUM__image_orientation';

export const ESearchImageOrientation = {
  ALL: 'ALL' as const,
  ...ENUM__image_orientation,
};
